
































































import Vue from "vue";
import Component from "vue-class-component";
import { GridOptions } from "ag-grid-community";
import {
    DefaultGridOptions,
    AjaxDataSource,
    initializeTable
} from "../../table";
import { IPromotionItemModel } from "../../models";
import { Inject, Prop } from "vue-property-decorator";
import { RestClient } from "@elite/restclient";
import PromotionManagementEvents from "./PromotionManagementEvents";

@Component
export default class PromotionLineItemGrid extends Vue {
    @Inject()
    restClient!: RestClient;

    gridOptions: GridOptions = new DefaultGridOptions();

    dataSource!: AjaxDataSource<IPromotionItemModel>;

    @Prop({ required: true, type: Number })
    promotionId!: number;

    additionalData(): Record<string, string> {
        return {
            promotionId: this.promotionId.toString()
        };
    }

    get refreshEventName() {
        return PromotionManagementEvents.promotionItemGridRefreshEvent;
    }

    mounted(): void {
        this.dataSource = new AjaxDataSource<IPromotionItemModel>(
            this.restClient,
            "/api/PromotionItemGrid",
            this.additionalData
        );

        initializeTable(
            this.gridOptions,
            this.dataSource,
            this.refreshEventName,
            this
        );
    }
}
